export default __webpack_public_path__ + "static/media/editing_transactions.47b8a14c.png";